/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCompleteRecoveryCodeRequest
 */
export interface ControlCompleteRecoveryCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlCompleteRecoveryCodeRequest
     */
    mfa_token: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCompleteRecoveryCodeRequest
     */
    recovery_code: string;
}

/**
 * Check if a given object implements the ControlCompleteRecoveryCodeRequest interface.
 */
export function instanceOfControlCompleteRecoveryCodeRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mfa_token" in value;
    isInstance = isInstance && "recovery_code" in value;

    return isInstance;
}

export function ControlCompleteRecoveryCodeRequestFromJSON(json: any): ControlCompleteRecoveryCodeRequest {
    return ControlCompleteRecoveryCodeRequestFromJSONTyped(json, false);
}

export function ControlCompleteRecoveryCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCompleteRecoveryCodeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mfa_token': json['mfa_token'],
        'recovery_code': json['recovery_code'],
    };
}

export function ControlCompleteRecoveryCodeRequestToJSON(value?: ControlCompleteRecoveryCodeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mfa_token': value.mfa_token,
        'recovery_code': value.recovery_code,
    };
}

